import React from 'react';
import { Text } from '@gluestack-ui/themed';

/** STUDENTS and SUPERVISORS header rows share one height so both first items start level. */
export const PREFLIGHT_COLUMN_TITLE_HEIGHT = 20;

const UPPERCASE = { textTransform: 'uppercase' as const };

/** Column label in the pre-flight table and supervisors headers. */
export function PreflightColumnLabel({
  children,
  testID,
}: {
  children: string;
  testID?: string;
}) {
  return (
    <Text
      size="xs"
      fontWeight="bold"
      color="$textHint"
      numberOfLines={1}
      style={UPPERCASE}
      testID={testID}
    >
      {children}
    </Text>
  );
}
